<div class="root-div">
  <p-select class="small-select" [options]="myViews" [(ngModel)]="selectedViewType" optionLabel="label" optionValue="type" (onChange)="onViewTypeChange($event.value)" [appendTo]="'body'"></p-select>
</div>
